import Hero from './components/Hero';
import CategoryNav from './components/CategoryNav';
import MovieSection from './components/MovieSection';
import { featuredMovies, latestMovies, actionMovies, comedyMovies, classicMovies } from '@/mocks/movies';
import { siteInfo } from '@/mocks/site';

export default function Home() {
  const homeSchema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '6080影院',
        url: 'https://www.6080cinema.com',
        description: siteInfo.description,
        contactPoint: {
          '@type': 'ContactPoint',
          email: siteInfo.contact.email,
          telephone: siteInfo.contact.phone,
          contactType: 'customer service',
        },
      },
      {
        '@type': 'WebSite',
        name: '6080影院',
        url: 'https://www.6080cinema.com',
        description: siteInfo.description,
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://www.6080cinema.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '6080影院 - 电影大全首页',
        description: '6080影院首页，提供最新电影、经典电影、动作电影、喜剧电影等全分类免费高清在线观看',
        url: 'https://www.6080cinema.com',
        isPartOf: { '@type': 'WebSite', name: '6080影院' },
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <Hero />
      <CategoryNav />
      <MovieSection
        title="推荐大片"
        subtitle="精选高分佳作，不容错过"
        movies={featuredMovies.slice(0, 6)}
        viewAllLink="/category/all"
        variant="featured"
      />
      <div className="bg-background-100">
        <MovieSection
          title="最新电影"
          subtitle="院线新片，第一时间上线"
          movies={latestMovies}
          viewAllLink="/category/latest"
        />
      </div>
      <MovieSection
        title="动作电影"
        subtitle="热血沸腾的动作大片"
        movies={actionMovies}
        viewAllLink="/category/action"
      />
      <div className="bg-background-100">
        <MovieSection
          title="喜剧电影"
          subtitle="欢乐不断，笑料百出"
          movies={comedyMovies}
          viewAllLink="/category/comedy"
        />
      </div>
      <MovieSection
        title="经典电影"
        subtitle="历经时间考验的不朽佳作"
        movies={classicMovies}
        viewAllLink="/category/classic"
      />
      <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
        <div className="max-w-[1280px] mx-auto text-center">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-4 font-heading">为什么选择6080影院？</h2>
          <p className="text-sm text-foreground-500 mb-10 max-w-2xl mx-auto">
            作为国内领先的电影大全平台，我们致力于为每一位用户提供极致的观影体验
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {siteInfo.features.map((feature) => (
              <div key={feature.title} className="p-6 bg-background-50 rounded-lg border border-background-200/60 text-center">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-500/10">
                  <i className="ri-check-double-line text-xl text-accent-600"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 font-heading">{feature.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}